module.exports = __webpack_public_path__ + "static/media/HeroGraphic.3decd338.png";